<template>
  <div class="w-64">
    <MultiSelect
      :value="selectedValue"
      :options="projects"
      :searchable="true"
      :can-clear="false"
      :can-deselect="false"
      placeholder="Alle projecten"
      no-options-text="Geen projecten beschikbaar"
      no-results-text="Geen project gevonden"
      @input="onChange"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MultiSelect from '@/components/shared/MultiSelect.vue'

export default {
  name: 'DropDownProject',
  components: { MultiSelect },
  computed: {
    ...mapState(['selectedProject', 'selectedWoco', 'user', 'selectedYear']),
    projects() {
      if (this.selectedWoco === null || this.selectedWoco === undefined) {
        return []
      }
      const woco = this.user.wocos.find((w) => w.name === this.selectedWoco)

      if (woco === undefined) {
        return []
      }

      return ['Alle projecten', ...woco.available_years[this.selectedYear]]
    },
    // The store also holds the legacy 'Alle Projecten' spelling, so match the
    // option case-insensitively; without a matching option the select would
    // render blank instead of falling back to the first option like a native
    // <select> does.
    selectedValue() {
      const selected = String(this.selectedProject || '').toLowerCase()
      return this.projects.find((project) => project.toLowerCase() === selected) || this.projects[0]
    },
  },
  methods: {
    ...mapActions(['setSelectedProject']),
    onChange(value) {
      this.setSelectedProject(value)
    },
  },
  mounted() {
    const woco = this.user.wocos.find((w) => w.name === this.selectedWoco)

    if (
      !this.selectedProject ||
      !woco.available_years[this.selectedYear].includes(this.selectedProject)
    ) {
      this.setSelectedProject('Alle Projecten')
    } else {
      this.setSelectedProject(this.selectedProject)
    }
  },
}
</script>
